import React from 'react';

const ShowError = ({ children }) => {
    return (
        <small className="text-red-400 mb-3 mt-1 block whitespace-pre-line">
            {children}
        </small>
    );
}

export default ShowError;
